
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'NotAllowedSettings',
})
export default class NotAllowedSettings extends Vue {
  @Prop({ required: true }) private message!: string;
}
